/**
 * SpecialtyPharmacyPreDeterminationStatusSection - Output section for SP pre-det status
 *
 * Displays specialty pharmacy pre-determination status as a top-level accordion section.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface SpecialtyPharmacyPreDeterminationStatusSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const SpecialtyPharmacyPreDeterminationStatusSection: React.FC<
  SpecialtyPharmacyPreDeterminationStatusSectionProps
> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Specialty Pharmacy Pre Determination Status</span>
          <SectionTriggerScore subsectionKey="specialty_pharmacy_pre_determination_status" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.specialty_pharmacy_pre_determination_status">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Available"
              value={data?.specialty_pharmacy_pre_determination_available}
              fieldId="specialty_pharmacy_pre_determination_available"
            />
            <Field
              label="On File Exists"
              value={data?.specialty_pharmacy_pre_determination_on_file_exists}
              fieldId="specialty_pharmacy_pre_determination_on_file_exists"
            />
            <Field
              label="On File"
              value={data?.specialty_pharmacy_pre_determination_on_file}
              fieldId="specialty_pharmacy_pre_determination_on_file"
            />
            <Field
              label="Reference Number"
              value={data?.specialty_pharmacy_pre_determination_reference_number}
              fieldId="specialty_pharmacy_pre_determination_reference_number"
            />
            <Field
              label="Effective Date"
              value={data?.specialty_pharmacy_pre_determination_effective_date}
              fieldId="specialty_pharmacy_pre_determination_effective_date"
            />
            <Field
              label="End Date"
              value={data?.specialty_pharmacy_pre_determination_end_date}
              fieldId="specialty_pharmacy_pre_determination_end_date"
            />
            <Field
              label="Quantity Limits"
              value={data?.specialty_pharmacy_pre_determination_quantity_limits}
              fieldId="specialty_pharmacy_pre_determination_quantity_limits"
            />
            <Field
              label="Quantity Used"
              value={data?.specialty_pharmacy_pre_determination_quantity_limits_used}
              fieldId="specialty_pharmacy_pre_determination_quantity_limits_used"
            />
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
